import { ApolloClient, InMemoryCache } from '@apollo/client';

console.log(process.env);
const client = new ApolloClient({
    uri: process.env.REACT_APP_GRAPHQL_API_URL,
    cache: new InMemoryCache(),
});

export default client;
